import { Component, OnInit,ViewChild } from '@angular/core';
import { CommonService } from 'src/service/common.service';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { NativeService } from '../../../../service/native.service';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { BaseCase } from 'src/app/basecase';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseModal } from 'src/model';
import { WebParameterContext } from '../../../../model/common';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var app;
@Component({
  selector: 'app-a2-sales-newreport',
  templateUrl: './a2-sales-newreport.component.html',
  styleUrls: ['./a2-sales-newreport.component.scss']
})
export class A2SalesNewreportComponent  extends GridBaseCase {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  tabinde :number = 1;
  tabindexall:number = 1;
  beginDate:any = null;//开始日期
  endDate:any = null;//结束日期
  monthdate:any = null; //销量日期
  sureShow:boolean =false;
  attainmentName:any = "销售分类";
  RecordCount: Number = 0;//列表总数量
  dataArrayList: Array<any> = []; // 销量列表
  dataArrayListone: Array<any> = []; // 招募会员列表
  datatkpi: any = {maminfo:{},meminfo:{},huiyuaninfo:{}}; // 妈妈新客/忠实会员/守护计划
  RecordCountone:Number = 0; // 招募会员列表
  selectVal = null;//搜索月份
  pageName: string = null;
  pgId:string = null;
  storeId:string = null;
  a_FK_TBStore_ID:any; // 门店id
   nameTitle :any;
   nameTitle1:any;
   nameNumber:number=0;
   nameNumber1:number=0;
   numpercent:any; //达成率值
   retailkpi:any={};//retail 促销员身份
   ntsType:string="nts";
  xiaoliang:any={};//销量统计
  usercode:any="";//返回的用户Cdoe
  beginDatetext:string = "请选择";
  monthdatetext:string = "请选择";
  salectruestar:boolean = true;
  salectrueend:boolean = true;
  completiontimetext:string="请选择"; // 完成时间
  completiontime:boolean=true; // 完成时间是否显示清空
  completion:any = null;//完成日期
  vipTypeArr1=[
    {
    a_Name:"未迁移"
  },
  {
    a_Name:"已迁移"
  }
];//迁移类型数组
  vipTypeId:string="未迁移";//迁移类型id
  searchValue:any=null;//搜索事件
  constructor(
    private com: CommonService,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService
  ) { 
    super();
    this.beginDate = this.com.getYearMonth;
    this.endDate = this.com.getYearMonth;
    this.monthdate= this.com.getYearMonth;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.pgId = this.com.GetAccount.Id;
    if(this.com.GetStorageKey("tbstore")){
      this.storeId=this.com.GetStorageKey("tbstore")["ID"];
    }
    const _paramId = this.activaRouter.snapshot.paramMap.get("id");
    activaRouter.queryParams.subscribe(queryParams => {
      if(queryParams.ID){
        this.storeId = queryParams.ID;// 门店id
        this.pgId=null;
      }
      if(queryParams.userCode){//门店code
        this.usercode=queryParams.userCode;
      }
      if(queryParams.yearmonth){
        this.beginDate = queryParams.yearmonth;
        this.monthdate= queryParams.yearmonth;
      }
     console.log(this.monthdate,"月份&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
      console.log(this.a_FK_TBStore_ID,"门店id***************************")
  });
  this.ntsType=this.com.GetAccount.BuType||"";
  this.recruitNember(1); // 招募会员列表
  if(this.ntsType.toLowerCase()=="retail"){
    this.attainmentName="产品";
    this.myKPIRetail();
  }else if(this.ntsType.toLowerCase()=="gtbbs"){
    this.attainmentName="产品";
    this.myKPIRetail();
  }
  else{
    
    this.myKPI();
  }
  }
   // 切换显示
   tabEven(num){
    const that = this;
    that.tabinde = num;
    if( that.tabinde == 2 ){
      // debugger;
      that.salesNemberList(1);
      if(that.ntsType.toLowerCase()=="nts"){
        that.salesNemberListKPI();
      }
    }
    if(that.tabinde == 1){
      that.recruitNember(1);
      if(this.ntsType.toLowerCase()=="retail"){
        that.myKPIRetail();
      }else{
        that.myKPI();
      }
    }
    if(that.tabinde == 1){
      that.recruitNember(1);
      if(this.ntsType.toLowerCase()=="gtbbs"){
        that.myKPIRetail();
      }else{
        that.myKPI();
      }
    }
  }
  // 销量类别切换显示
  // 切换显示
  tabEventdetail(num){
    const that = this;
    that.tabindexall = num;
    switch(num){
      case 1:
        if(that.ntsType.toLowerCase()=="nts"){
          that.attainmentName = "销售分类";
        }else{
          that.attainmentName="产品";
         
        }
        
        break;
        case 2:
          that.attainmentName = "品牌";
        break;
        case 3:
          that.attainmentName = "品类";
        break;

    }
    that.salesNemberList(1);
  }
  dateSeach(){
    const that = this;
    that.sureShow= true;
  }
   // 日期查询
   EventDateTimeClick() {
    let that = this;
    console.log(that.beginDate);
    //debugger;
    let _obj = {
      value: that.beginDate,
      format: "yyyymm"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.beginDate = that.formatDate(data.value);
      // if(new Date(that.endDate.replace(/-/g,"/")).getTime() < new Date(that.beginDate.replace(/-/g,"/")).getTime()){
      //   that.msg.Alert("开始日期必须小于结束日期！");
      //   that.beginDate = that.endDate;
      // }
      // console.log("测试");
      that.salectruestar = true;
      if(that.ntsType.toLowerCase()=="retail"){
        that.myKPIRetail();
      }else if(that.ntsType.toLowerCase()=="gtbbs"){
        that.myKPIRetail();
      }
      else{
        that.myKPI();
      }
    
     that.recruitNember(1);
    }).catch(eror => {
      console.log(eror);
      // that.beginDate = "";
    });
  }
  // 完成时间
  EventDateTimeClickcompletion() {
    let that = this;
    console.log(that.beginDate);
    //debugger;
    let _obj = {
      value: that.completion,
      format: "yyyymm"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.completion = that.formatDate(data.value);
      that.completiontime = false;
      if(that.ntsType.toLowerCase()=="retail"){
        that.myKPIRetail();
      }else if(that.ntsType.toLowerCase()=="gtbbs"){
        that.myKPIRetail();
      }
      else{
        that.myKPI();
      }
    
     that.recruitNember(1);
    }).catch(eror => {
      console.log(eror);
      // that.beginDate = "";
    });
  }
  completioncloseStar(){
    const that =this;
    that.completion = "";
    that.completiontime = true;
    if(that.ntsType.toLowerCase()=="retail"){
      that.myKPIRetail();
    }else if(that.ntsType.toLowerCase()=="gtbbs"){
      that.myKPIRetail();
    }
    else{
      that.myKPI();
    }
    that.recruitNember(1);
  }
  closeStar(){
    const that =this;
    that.beginDate = "";
    that.salectruestar = false;
  }
    // 日期查询
    EventDateTimeClick1() {
      console.log("测试1");
      let that = this;
      console.log(that.endDate);
      let _obj = {
        value: that.endDate,
        format: "yyyymm"
      };
      that.native.IosselectDateTime(_obj).then(data => {
        that.endDate = that.formatDate(data.value);
        if(new Date(that.endDate.replace(/-/g,"/")).getTime() < new Date(that.beginDate.replace(/-/g,"/")).getTime()){
          that.msg.Alert("结束日期必须要大于开始日期哦！");
          that.sureShow= true;
        }else if(new Date(that.endDate.replace(/-/g,"/")).getTime() > new Date(that.beginDate.replace(/-/g,"/")).getTime()){
          that.sureShow= false;
        }
        console.log("测试");
      }).catch(eror => {
        console.log(eror);
      });
    }
    // 销量日期查询
    saledateSeach(){
      console.log("测试1");
      let that = this;
     
      console.log(that.monthdate);
      let _obj = {
        value: that.monthdate,
        format: "yyyymm"
      };
      that.native.IosselectDateTime(_obj).then(data => {
        that.monthdate = that.formatDate(data.value);
        console.log("测试");
        that.salesNemberList(1);
        if(that.ntsType.toLowerCase()=="nts"){
          that.salesNemberListKPI();
        }
        that.salectrueend = true;
      }).catch(eror => {
        console.log(eror);
        // that.monthdate= "";
      });
    }
    closeEnd(){
      const that =this;
      that.monthdate= "";
      that.salectrueend = false;
    }
  formatDate(date) {
    if (date) {
      let _y = date.split("-")[0];
      let _m = date.split("-")[1];
      // let _d = _date.getDate();
      // return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
      return _y + "/" + (_m < 10 ? "0" + _m : _m);
    } else {
      return date;
    }
  }
    // 选择日期开始
    sureModal(){
      const that =this;
      let beginDate = new Date(that.beginDate.replace(/-/g,"/")).getTime();
      let endDate = new Date(that.endDate.replace(/-/g,"/")).getTime();
      if(endDate<= beginDate){
        that.msg.Alert("结束日期必须要大于开始日期哦！");
      }else{
        that.sureShow= false;
      }
    }
    
    // 选择日期结束
    dissModal(){
      const that = this;
      that.sureShow= false;
    }
  // 点击查询开始时间结束时间时间段
  seach(){
    console.log("查询")
    const that =this;
    that.sureShow= false;
    let beginDate = new Date(that.beginDate.replace(/-/g,"/")).getTime();
    // let endDate = new Date(that.endDate.replace(/-/g,"/")).getTime();
    // if(endDate<= beginDate){
    //   that.msg.Alert("结束日期必须要大于开始日期哦！");
    //   return;
    // }
    
    if(that.ntsType.toLowerCase()=="retail"){
      that.myKPIRetail();
    }else if(that.ntsType.toLowerCase()=="gtbbs"){
      that.myKPIRetail();
    }
    else{
      that.myKPI();
    }
    
    that.recruitNember(1);

  }
  // 销量搜索
  salesReport(){
    const that =this;

    // if(!that.monthdate){
    //     that.msg.Alert("日期不能为空哦！请选择日期");
    //     return;
    // }
    that.salesNemberList(1);
    if(that.ntsType.toLowerCase()=="nts"){
      that.salesNemberListKPI();
    }
    // 
  }
  /**
   * 我的NTS kpi指标接口
   */
  myKPI(){
    var that = this;
      // that.loading = false;
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = '';
    
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBSNCMemberInfoXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.ClientType = 2;

    let typeObj = {};
    typeObj["a_FK_TBStore_ID"]=that.storeId;
    if(that.beginDate){
      typeObj["a_TargetTime"] = that.beginDate+"/01";
    }
    if(that.completion){
      typeObj["SNC_Validation_Date_Start"]=that.completion.replace("/","-")+"-01 00:00:00";
      typeObj["SNC_Validation_Date_End"]=that.completion.replace("/","-")+"-"+that.getCountDays(that.completion+"-01")+" 23:59:59";;
    }
    if(that.pgId){
      typeObj["a_FK_SystemUser_ID"] = that.pgId;
    }
    // typeObj["a_FK_TBStore_ID"]="E6515FA2-FCC0-4962-9AD3-A29B93954EC4";
    // typeObj["a_TargetTime"] = "2020-05-17";
    // typeObj["a_FK_SystemUser_ID"] = "578B9934-2916-491D-B266-000A7CABEBF3";
    
   
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
        // that.baseService.arrayData = [];
        that.datatkpi = {maminfo:{},meminfo:{},huiyuaninfo:{}}; // 妈妈新客/忠实会员
        // that.apiObj['status'] = data.ResponseMessage.Success;
        // that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        // that.loading = true;
      
      if (data.ResponseMessage.Success) {
        that.datatkpi = {maminfo:{},meminfo:{},huiyuaninfo:{}}; // 妈妈新客/忠实会员/守护计划
       let arraykpiArray:Array<any> = data.Status.Datas||[];
       if(arraykpiArray.length>0){
          let menber:any={};//忠实会员
          let maminfo:any={};//妈妈新客
          let shouhuin:any ={}; // 守护计划
          if( arraykpiArray.filter(item=>item.a_Code=="0").length>0){
           menber=arraykpiArray.filter(item=>item.a_Code=="0")[0];
           if(!menber.a_Value){
               menber.a_Value=0;
           }
           if(!menber.a_Num){
                 menber.a_Num=0;
             }
          }
          if(arraykpiArray.filter(item=>item.a_Code=="3").length>0){
           maminfo=arraykpiArray.filter(item=>item.a_Code=="3")[0];
           if(!maminfo.a_Value){
            maminfo.a_Value=0;
           }
           if(!maminfo.a_Num){
            maminfo.a_Num=0;
           }
          }
           // 守护计划数据
           if(arraykpiArray.filter(item=>item.a_Code=="4").length>0){
            shouhuin=arraykpiArray.filter(item=>item.a_Code=="4")[0];
            if(!shouhuin.a_Value){
              shouhuin.a_Value=0;
            }
            if(!shouhuin.a_Num){
              shouhuin.a_Num=0;
            }
           }
          that.datatkpi.maminfo=maminfo;
          that.datatkpi.meminfo =menber;
          that.datatkpi.huiyuaninfo =shouhuin;

       }
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      // console.log(error);
    });
  }
    /**
   * 我的 Retail kpi指标接口
   */
  myKPIRetail(){
    var that = this;
      // that.loading = false;
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = '';
    
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "GetRetailKPI";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.ClientType = 2;

    let typeObj = {};
    typeObj["a_Year"] = that.beginDate.split("/")[0];
    typeObj["a_Month"] = that.beginDate.split("/")[1];
    typeObj["Code"]=that.com.GetAccount.CustomerID;
    if(that.usercode){
      typeObj["Code"]=that.usercode;
    }
    if(that.completion){
      typeObj["SNC_Validation_Date_Start"]=that.completion.replace("/","-")+"-01 00:00:00";
      typeObj["SNC_Validation_Date_End"]=that.completion.replace("/","-")+"-"+that.getCountDays(that.completion+"-01")+" 23:59:59";;
    }
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
        // that.baseService.arrayData = [];
     
        // that.apiObj['status'] = data.ResponseMessage.Success;
        // that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        // that.loading = true;
      
      if (data.ResponseMessage.Success) {
        that.retailkpi=data.Status.Datas || {};//获取 retail 会员身份
        that.retailkpi.zongshu=parseInt(that.retailkpi.CountLoyal||0)+parseInt(that.retailkpi.CountMMP||0)+parseInt(that.retailkpi.CountS3||0);//招募会员总数
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      // console.log(error);
    });
  }
  /**
   * 招募会员接口
   * 
   * 获取
   */

  loadMoreData1(event) {
    let that = this;
    if (that.RecordCountone == that.dataArrayListone.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      that.recruitNember(that.PageNumber);
    }
  }
  /**
   * 招募会员
   * @param PageNumber 
   */
  recruitNember(PageNumber){
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
      that.dataArrayListone=[];
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "MemberListInfo";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.RequestBody={};
    body.RequestBody["mobile"]="";
    body.RequestBody["joindateStart"]="";
    body.RequestBody["joindateEnd"]="";
    body.RequestBody["newCustomerType"]="";
    body.RequestBody["type"]="";
    if(that.beginDate){
      body.RequestBody["joindateStart"]=that.beginDate.replace("/","-")+"-01 00:00:00";
      body.RequestBody["joindateEnd"]=that.beginDate.replace("/","-")+"-"+that.getCountDays(that.beginDate+"-01")+" 23:59:59";;
    }
    if(that.completion){
      body.RequestBody["SNC_Validation_Date_Start"]=that.completion.replace("/","-")+"-01 00:00:00";
      body.RequestBody["SNC_Validation_Date_End"]=that.completion.replace("/","-")+"-"+that.getCountDays(that.completion+"-01")+" 23:59:59";;
    }
    body.RequestBody["Code"]=that.com.GetAccount.CustomerID;
    body.RequestBody["type"]="kpi";
    if(that.usercode){
      body.RequestBody["Code"]=that.usercode;
    }
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData = [];
        that.dataArrayListone = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      // debugger;
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          that.dataArrayListone.push(item);
        });
        that.dataArrayListone.forEach(item=>{
          if(item.Name){//姓名
            item.Name=that.com.FormatName(item.Name||"");
          }
          if(item.Mobile){//手机号码
            item.Mobile=that.com.PhoneNum(item.Mobile.toString()||"");
          }
          if(item.BabyBirthDay){//宝宝生日
            item.BabyBirthDay= item.BabyBirthDay.replace(/-/g,"/").replace("T","");
          }
          if(item.Joindate){//招募日期
            item.Joindate= item.Joindate.replace(/-/g,"/").replace("T"," ");
          }
          if(item.CSR_CallTime){//完成日期
            item.CSR_CallTime= item.CSR_CallTime.replace(/-/g,"/").replace("T"," ");
          }
          if(!item.IsMembers){//标识失败
            let msg:any = item.Result.split("【")[1];
            if(msg){
              item.Result = "【"+msg;
            }
            
          }
        });
        /****上拉加载数据begin****/
        that.RecordCountone = data.Status.RecordCount;
        if (that.RecordCountone == data.Status.Datas.length || that.RecordCountone == that.dataArrayListone.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else{
        // that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }
  // 销量会员列表
  /**
   * 
   * @param pageName 
   * saletyp kpi分类 brandtype 品牌分类    producttype 产品品类
   */
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      that.salesNemberList(that.PageNumber);
    }
  }
   /**
   * 返回这个月有多少天
   * @param data 当前日期
   */
  getCountDays(data){
    let curDate:any = new Date(data.replace("-","/"));
    /* 获取当前月份 */
        var curMonth = curDate.getMonth();
        curDate.setMonth(curMonth + 1);
        curDate.setDate(0);
        console.log(curDate.getDate(),"返回日期");
        return curDate.getDate();
  }
  salesNemberList(PageNumber){
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBSNCSaleInfoXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    if(that.tabindexall == 1){
      if(that.ntsType.toLowerCase()=="nts"){
        body.SpecialParameter= "categorytype";
      }else{
        body.SpecialParameter= "procductshortname";
      }
      
    }
    if(that.tabindexall == 2){ 
      body.SpecialParameter= "brandtype";
    }
    if(that.tabindexall == 3){
      body.SpecialParameter= "producttype";
    }
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {};
    // typeObj["a_FK_SystemUser_ID"] = that.pgId;
    typeObj["a_UpTime"] = that.monthdate+"/01";
    // typeObj["a_UpTime"] = "2020/07/01";
    typeObj["StoreId"]=that.storeId;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        let tempArray:Array<any> = new Array<any>();
        // if(that.ntsType.toLowerCase()!="nts"){
        //   tempArray=data.Status.Datas.SaleData;
        //   that.xiaoliang["SalePriceTotal"]=data.Status.Datas.SalePriceTotal || 0;//金额
        //   that.xiaoliang["TargetPrice"]=data.Status.Datas.TargetPrice || 0;//指标
        // }else{
        //   tempArray=data.Status.Datas;
        // }
          tempArray=data.Status.Datas.SaleData;
          that.xiaoliang["SalePriceTotal"]=data.Status.Datas.SalePriceTotal || 0;//金额
          that.xiaoliang["TargetPrice"]=data.Status.Datas.TargetPrice || 0;//指标

          that.xiaoliang["NonBMSTotal"]=data.Status.Datas.NonBMSTotal || 0;//NonBMS 销量
          that.xiaoliang["NonBMSTarget"]=data.Status.Datas.NonBMSTarget || 0;//NonBMS Target 是目标

          that.xiaoliang["BMSTotal"]=data.Status.Datas.BMSTotal || 0;//BMS 销量
          that.xiaoliang["BMSTarget"]=data.Status.Datas.BMSTarget || 0;//BMS Target 是目标
          console.log( that.xiaoliang);
        tempArray.forEach(element => {
          that.dataArrayList.push(element);
        });
        console.log(that.dataArrayList, "dataArrayList");
      //  //debugger;
       
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == tempArray.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }
  salesNemberListKPI(){
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBSNCSaleInfoXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.SpecialParameter= "saletype";
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let typeObj = {};
    // typeObj["a_FK_SystemUser_ID"] = that.pgId;
    typeObj["a_UpTime"] = that.monthdate+"/01";
    // typeObj["a_UpTime"] = "2020/07/01";
    typeObj["StoreId"]=that.storeId;
    body.RequestBody = JSON.stringify(typeObj);
    let arrardate:Array<any> = new Array<any>();
    that.http.post(app.DEFAULTURL, body).then(data => {
      // debugger;
      if (data.ResponseMessage.Success) {
        data.Status.Datas.SaleData.forEach(element => {
          arrardate.push(element);
        });
      //  //debugger;
          that.nameNumber1 = 0;
          that.nameNumber = 0;
          // 达成数量除以目标数量
          //SaleNum 达成数量字段 分子
          // TargetNum  目标数量  分母
          if( arrardate.filter(item=>item.Name=='BMS').length>0){
            let item=arrardate.filter(item=>item.Name=='BMS')[0];
             // //debugger;
             that.nameTitle1 = "BMS产品供应预估准确率";
             let num:number = Number.parseInt(item.TargetPrice) ; // 分母 分母TargetNum
             let num2:number = Number.parseInt(item.SalePrice) ;  // 分子SaleNum
               let num4:number = 0;
               if(num==0){//如果分母为零分子不为零则为100%;
                 if(num2){
                   num4=0;
                 }else{
                   num4 = 0;
                 }
               }else{
                 num4 =(num2/num)*100 ;
               }
                that.nameNumber1 = num4;
                console.log(that.numpercent);
           }
           if(arrardate.filter(item=>item.Name=='Non-BMS').length>0){
             let item=arrardate.filter(item=>item.Name=='Non-BMS')[0];
             that.nameTitle = item.Name;
             let num:number = Number.parseInt(item.TargetPrice) || 0; // 分母 分母TargetNum
             let num2:number = Number.parseInt(item.SalePrice) || 0;  // 分子SaleNum
               let num4:number = 0;
               if(num==0){//如果分母为零分子不为零则为100%;
                 if(num2){
                   num4=0;
                 }else{
                   num4 = 0;
                 }
               }else{
                 num4 =(num2/num)*100 ;
                
               }
               that.nameNumber = num4;
               console.log(that.numpercent);
           }
        
      }

    }).catch(error => {
     
      // console.log(error);
    });
  }
  // 微信迁移
  //会员类型改变
  changeTypeSelect(e)
  {
    const that=this;
    that.vipTypeId=e.target.value;
    if(that.vipTypeId=="全部"){
      that.vipTypeId="";
    }
    
    // that.LoadData(1);
  }
  // 搜索事件
  serarEvent(e,type:string = 'type'){ 
    const that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    if(e.keyCode == 13 || type=='search'){
      // const _searchObj = {
      //   pageName:PageName,
      //   searchInput:that.searchValue,
      //   campaigInput:that.campaignValue
      // };
      // that.com.SaveSearchInfo(_searchObj);
      // this.LoadData(1);
    }
  }
}
